<template>
  <div>
    <BreadCrumd
      :title="'Remplacements'"
      :description="'Liste des remplacements'"
    />
    <div class="mt-2 mb-4">
      <div class="row d-flex justify-content-end">
        <div class="col-md-3 col-lg-6 text-right">
          <button
            type="button"
            class="btn btn-custom-primary"
            @click.prevent="
              $router.push({ name: routes.create }).catch(() => {})
            "
          >
            <i class="fas fa-plus"></i>
            Nouveau remplacement
          </button>

          <button
            type="button"
            class="btn btn-danger ml-4"
            @click.prevent="deleteAllSelection"
            v-show="isSelect"
          >
            <i class="fas fa-trash"></i>
            Supprimer
          </button>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <DataTable
            ref="datatable"
            @onSelect="onSelectRows"
            @onRowsDelete="deleteRows"
            :headers="selectedHeaders"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../components/DataTable.vue';
import URL from '@/http/remplacement';
import names from '@/constants/routes/remplacement';

export default {
  data() {
    return {
      title: 'Gestion des chantiers',
      isSelect: false,
      selectedTiersTypes: null,
      selectedHeaders: [],
      tiersTypes: [],
      routes: names,
      headers: [
        {
          text: 'Employé',
          align: 'start',
          sortable: true,
          value: 'employe',
        },
        {
          text: 'Remplaçant',
          align: 'start',
          sortable: false,
          value: 'remplacant',
        },
        {
          text: 'Date debut',
          align: 'start',
          sortable: false,
          value: 'date_debut',
        },
        {
          text: 'Date fin',
          align: 'start',
          sortable: false,
          value: 'date_fin',
        },
        {
          text: 'Type contrat',
          align: 'start',
          sortable: false,
          value: 'type_contrat',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },
  created() {
    this.selectedHeaders = this.headers;
  },
  watch: {
    selectedHeaders() {
      this.selectedHeaders =
        this.selectedHeaders.length === 0 ? this.headers : this.selectedHeaders;
    },
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    DataTable,
  },
  methods: {
    updateSelect(values) {
      let ids = values.map((a) => a.id);
      this.$refs.datatable.setFilter(ids);
      this.$refs.datatable.loadItems();
    },
    onSelectRows(isSelect) {
      this.isSelect = isSelect;
    },
    deleteAllSelection() {
      this.deleteRows(this.$refs.datatable.idsRowsSelected);
    },
    deleteRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.REMPLACEMENT, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatable.loadItems();
                this.isSelect = false;
              })
              .catch();
          }
        });
      }
    },
  },
};
</script>

<style scoped></style>
